import * as React from 'react';

/** Material UI Packages. */
import { Box, Button } from '@mui/material';
import { randomId } from '@mui/x-data-grid-generator';
import { GridRowModes, GridToolbarContainer, GridToolbarQuickFilter } from '@mui/x-data-grid-premium';

/** Material UI Icons. */
import AddIcon from '@mui/icons-material/Add';
import SaveIcon from '@mui/icons-material/Save';
import ContentCopyRoundedIcon from '@mui/icons-material/ContentCopyRounded';

/**
 * @brief Handler to create a new row into datagrid & Quick filter(searchbar).
 * @param {setDoRow,setRowModesModel} props from NewContainer
 * @returns setDoRow
 */
export default function CustomToolbar(props) {
    const {
        doRow,
        setDoRow,
        rowModesModel,
        setRowModesModel,
        saveDisableBtn,
        setSaveDisableBtn,
        apiRequest,
        userId,
        setDispatch,
        setSnackbar,
        selectedRowIds,
    } = props;

    const newRowhandleClick = () => {
        const id = randomId();
        setDoRow((oldRows) => [
            {
                id,
                dispatch_type: true,
                team: '',
                client: '',
                mbl: '',
                cntr: '',
                size: '',
                terminal: '',
                vessel: '',
                eta: '',
                etb: '',
                dem: '',
                appt: null,
                obl: false,
                customs: false,
                pierpass: false,
                remark: '',
                link: '',
                isNew: true,
            },
            ...oldRows,
        ]);
        setRowModesModel((oldModel) => ({
            ...oldModel,
            [id]: { mode: GridRowModes.Edit, fieldToFocus: 'cntr' },
        }));
        setSaveDisableBtn(false);
    };

    const handleSaveClick = () => {
        const editingRowExist = Object.values(rowModesModel).some((row) => row.mode === GridRowModes.Edit);
        const updatedRow = [...doRow].filter((item) => item.isNew == true);

        if (editingRowExist) {
            setSnackbar({
                open: true,
                message: 'Please save or cancel the editing rows before dispatching.',
                severity: 'warning',
            });
            return;
        }
        apiRequest('deliveryorder', 'dispatch', userId, updatedRow)
            .then((response) => {
                if (response.statusCode === 200) {
                    setDispatch(response.body.data);
                    setSnackbar({ open: true, message: response.body.message, severity: 'success' });
                } else {
                    setSnackbar({ open: true, message: response.body.message, severity: 'error' });
                }
            })
            .catch((error) => {
                setSnackbar({ open: true, message: 'Something went wrong. Please try again.', severity: 'error' });
            });
        setSaveDisableBtn(true);
    };

    const handleCopyClick = () => {
        if (selectedRowIds.length === 0) {
            setSnackbar({ open: true, message: 'Please select a row to copy.', severity: 'warning' });
            return;
        }
        // Check if any row in edit mode
        const duplicatedRows = doRow
            .filter((row) => selectedRowIds.includes(row.id))
            .map((row) => ({
                ...row,
                id: randomId(),
                appt: null,
                obl: false,
                customs: false,
                pierpass: false,
                remark: '',
                link: '',
                isNew: true, // Mark as new for saving
            }));
        setDoRow((oldRows) => [...duplicatedRows, ...oldRows]);
        setRowModesModel((oldModel) => {
            const newModel = { ...oldModel };
            duplicatedRows.forEach((row) => {
                newModel[row.id] = { mode: GridRowModes.Edit };
            });
            return newModel;
        });

        setSnackbar({ open: true, message: 'Selected rows are copied successfully.', severity: 'success' });
        setSaveDisableBtn(false);
    };

    return (
        <GridToolbarContainer component="div">
            <Box width="100%" display="flex" flexDirection="row" justifyContent="center">
                <Box width="50%" display="flex" justifyContent="flex-start">
                    <Button
                        color="primary"
                        startIcon={<AddIcon />}
                        onClick={newRowhandleClick}
                        sx={{ color: '#00647e', fontWeight: '700' }}
                    >
                        Add Container
                    </Button>
                    <Button startIcon={<ContentCopyRoundedIcon />} onClick={handleCopyClick}>
                        Copy
                    </Button>
                    <Button startIcon={<SaveIcon />} onClick={handleSaveClick} disabled={saveDisableBtn}>
                        Save
                    </Button>
                </Box>
                <Box width="50%" display="flex" justifyContent="flex-end">
                    <GridToolbarQuickFilter />
                </Box>
            </Box>
        </GridToolbarContainer>
    );
}
